import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { toAbsoluteUrl } from "../../../_helpers";
import { MainImagePopup } from "./MainImagePopUp";
export const MainImageExpandedDetailsPopup = (props) => {
    const history = useHistory()
    const [mainimageclick,setMainImageClick] = useState(false)
    const ImageUrl = (data) => {
        let image = ""
        if (data.ext_status === "Success") {
            image = data.ext_img_runtime
        }
        else if (data.aws_image) {
            image = data.aws_image
        }
        return image
    }
    return (
        <>
            {props.data.image ? <div>
                <MainImagePopup Image={props.data.image} Shape={props.data.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                <LazyLoadImage
                    className="img-fluid cursor-pointer"
                    onClick={() => setMainImageClick(true)}
                    src={props.data.image}
                    alt={props.data.shape}
                    onError={e => {
                        e.currentTarget.src = toAbsoluteUrl(
                            `/media/shape/${props.data.shape.toLowerCase()}-no.png`
                        )
                    }}
                    effect="blur"
                />
            </div> : <div>
            <MainImagePopup Image={toAbsoluteUrl( `/media/shape/${props.data.shape.toLowerCase()}-no.png` )} Shape={props.data.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                <img
                    className="img-fluid cursor-pointer"
                    onClick={() => setMainImageClick(true)}
                    alt="shape"
                    src={toAbsoluteUrl(
                        `/media/shape/${props.data.shape.toLowerCase()}-no.png`
                    )}
                    onError={e => {
                        e.currentTarget.src = toAbsoluteUrl(
                            `/media/shape/noimage.jpg`
                        )
                    }}
                />
            </div>}
        </>
    );
};
